module.exports = __webpack_public_path__ + "static/yogi-square-058f56a3aa6407dfd8a34d2ee9a0caa5.jpg";